export default [
  {
    path: "/inspection/records/list",
    name: "inspection-records-list",
    meta: { title: "巡检记录" },
    component: () =>
      import(
        /* webpackChunkName: "inspection-records-list" */ "@/views/inspection-management/records/list/index.vue"
      ),
  },
  {
    path: "/inspection/records/detail/:id",
    name: "inspection-records-detail",
    meta: { title: "巡检详情" },
    component: () =>
      import(
        /* webpackChunkName: "inspection-records-detail" */ "@/views/inspection-management/records/detail/index.vue"
      ),
  },
];
